import { actions } from 'edrolo/reducers/edrolo';
import { connect } from 'react-redux';
import UniqueOverlayTrigger from './UniqueOverlayTrigger';

const mapStateToProps = (state, ownProps) => {
  return {
    isShown:
      state.edrolo.get('activeUniqueOverlayId') === ownProps.uniqueOverlayId,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    showOverlay: () => {
      dispatch(
        actions.overlayControl.showUniqueOverlay(ownProps.uniqueOverlayId)
      );
      ownProps.onShow();
    },

    hideOverlay: () => {
      dispatch(
        actions.overlayControl.hideUniqueOverlay(ownProps.uniqueOverlayId)
      );
      ownProps.onHide();
    },
  };
};

const ConnectedUniqueOverlayTrigger = connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true }
)(UniqueOverlayTrigger);

// in order to assume they exist in the dispatchToProps these need to be set here
ConnectedUniqueOverlayTrigger.defaultProps = {
  onShow: () => {},
  onHide: () => {},
};

export default ConnectedUniqueOverlayTrigger;
